import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Services.css";
import { scrollToSection } from "../../../utils/scroll";
import { handleSectionNavigation } from "../../../utils/navigation";
import { FiArrowUpRight, FiChevronDown } from "react-icons/fi";

import serviceConsignado from "../../../assets/images/services/service_consignado.webp";
import servicePortability from "../../../assets/images/services/service_portability.webp";
import serviceRefinancing from "../../../assets/images/services/service_refinancing.webp";
import serviceFgts from "../../../assets/images/services/service_fgts.webp";
import serviceMargin from "../../../assets/images/services/service_margin.webp";
import serviceCreditCard from "../../../assets/images/services/service_credit_card.webp";
import serviceClt from "../../../assets/images/services/service_clt.webp";

const Services = ({ onNavigate }) => {
  const [activeService, setActiveService] = useState(0);
  const [activeFaq, setActiveFaq] = useState(null);
  const navigate = useNavigate();

  const services = [
    {
      id: "consignado",
      title: "Consignado",
      description:
        "Crédito consignado para beneficiários do INSS e servidores de convênios, com taxas competitivas, possibilidade de redução de parcelas e opções de portabilidade com alto valor de troco.",
      image: serviceConsignado,
    },
    {
      id: "portabilidade",
      title: "Portabilidade",
      description:
        "Transfira seu contrato para outra instituição e busque condições mais adequadas para o seu momento financeiro.",
      image: servicePortability,
    },
    {
      id: "refinanciamento",
      title: "Refinanciamento",
      description:
        "Reorganize seu contrato buscando melhores condições e parcelas que façam mais sentido para o seu orçamento.",
      image: serviceRefinancing,
    },
    {
      id: "fgts",
      title: "Antecipação FGTS",
      description:
        "Antecipe parcelas do seu saldo do FGTS e consulte as possibilidades disponíveis para o seu perfil.",
      image: serviceFgts,
    },
    {
      id: "margem",
      title: "Liberação de Margem",
      description:
        "Consulte possibilidades relacionadas à sua margem consignável e encontre uma alternativa adequada às suas necessidades.",
      image: serviceMargin,
    },
    {
      id: "emprestimo-clt",
      title: "Empréstimo CLT",
      description:
        "Opção de crédito para trabalhadores com carteira assinada, com parcelas e condições definidas conforme o perfil e a margem disponível.",
      image: serviceClt,
    },
    {
      id: "cartoes",
      title: "Cartões RMC e RCC",
      description:
        "Consulte as possibilidades de cartões consignados RMC e RCC, de acordo com sua margem disponível e as condições da instituição financeira",
      image: serviceCreditCard,
    },
  ];


  const faqs = [
    {
      question: "A Egel realiza empréstimos pessoais?",
      content: (
        <>
          <p>
            Não. A Egel não oferece empréstimos pessoais convencionais. Nosso
            atendimento é direcionado às modalidades de crédito consignado e aos
            demais serviços financeiros disponibilizados em nosso site.
          </p>

          <p>
            Se você procura crédito, consulte as opções disponíveis em nossa página
            de serviços para verificar se alguma delas atende às suas necessidades.
          </p>
        </>
      ),
    },
    {
      question: "O que é a portabilidade de crédito?",
      content: (
        <>
          <p>
            A portabilidade de crédito permite transferir uma operação de crédito
            de uma instituição financeira para outra, conforme as condições
            aprovadas pela nova instituição.
          </p>

          <p>
            Na Egel, nosso compromisso é buscar, dentro das opções disponíveis,
            uma condição que seja mais adequada e vantajosa para o cliente,
            sempre considerando as características da operação, as taxas, o
            prazo, o saldo devedor e o valor da parcela.
          </p>

          <p>
            A Egel atua na intermediação e orientação do processo. A análise,
            aprovação e contratação são realizadas diretamente pela instituição
            financeira responsável pela operação.
          </p>
        </>
      ),
    },

    {
      question: "A portabilidade pode reduzir o valor da parcela?",
      content: (
        <>
          <p>
            Pode, dependendo das condições oferecidas pela nova instituição,
            do saldo devedor, da taxa de juros, do prazo e das características
            do contrato atual.
          </p>

          <p>
            Por exemplo: imagine um contrato que foi originalmente contratado
            com uma taxa de 1,40% ao mês. Se, no momento da portabilidade, a
            instituição que receberia o contrato trabalhar com uma taxa de
            1,57% ao mês, não há uma redução de juros pela simples realização
            da portabilidade. Nesse cenário, a nova taxa é superior à taxa
            originalmente contratada.
          </p>

          <p>
            Para que uma portabilidade possa proporcionar uma redução da parcela
            em razão da taxa de juros, é necessário que a nova proposta apresente
            condições financeiras melhores que as do contrato que será
            transferido. Além da taxa, também devem ser considerados o prazo,
            o saldo devedor, o valor da parcela e o CET da operação.
          </p>

          <p>
            Por isso, cada contrato precisa ser analisado individualmente.
            A portabilidade não garante redução da parcela ou dos juros.
          </p>
        </>
      ),
    },

    {
      question: "Qual é a diferença entre portabilidade e refinanciamento?",
      content: (
        <>
          <p>
            Na portabilidade, uma operação de crédito é transferida de uma
            instituição financeira para outra. No refinanciamento, a operação
            existente é renegociada ou substituída conforme as condições
            oferecidas pela instituição responsável.
          </p>

          <p>
            Dependendo da proposta aprovada, o refinanciamento pode alterar o
            prazo, o valor das parcelas e, em determinadas situações, liberar
            um valor adicional.
          </p>
        </>
      ),
    },

    {
      question: "Quem pode contratar o consignado INSS?",
      content: (
        <>
          <p>
            O crédito consignado INSS é destinado aos beneficiários que atendem
            às regras da modalidade e possuem margem consignável disponível.
          </p>

          <p>
            A Egel pode auxiliar na intermediação e orientação. A análise,
            aprovação e contratação são realizadas pela instituição financeira,
            de acordo com as regras aplicáveis a cada operação.
          </p>
        </>
      ),
    },

    {
      question: "O que é margem consignável?",
      content: (
        <>
          <p>
            Margem consignável é o limite disponível para comprometimento da
            renda em determinadas operações de crédito consignado.
          </p>

          <p>
            A margem disponível pode variar conforme o tipo de benefício,
            vínculo e regras vigentes. Ter margem disponível não significa
            aprovação automática de uma operação.
          </p>
        </>
      ),
    },

    {
      question: "Como funciona a antecipação do saque-aniversário do FGTS?",
      content: (
        <>
          <p>
            A antecipação do saque-aniversário é uma operação de crédito na qual
            o trabalhador recebe antecipadamente valores que teria direito a
            retirar nos próximos períodos de saque-aniversário.
          </p>

          <p>
            A Egel pode auxiliar na intermediação do processo. A análise,
            aprovação e contratação são realizadas pela instituição financeira
            responsável pela operação, conforme as regras vigentes.
          </p>
        </>
      ),
    },

    {
      question: "O que é liberação de margem?",
      content: (
        <>
          <p>
            A liberação de margem ocorre quando parte da margem consignável que
            estava comprometida deixa de estar vinculada a uma operação,
            podendo aumentar o espaço disponível para uma nova contratação.
          </p>

          <p>
            A disponibilidade de margem não garante aprovação de um novo
            crédito. A contratação depende da análise e das condições da
            instituição financeira.
          </p>
        </>
      ),
    },

    {
      question: "É possível receber um valor adicional no refinanciamento?",
      content: (
        <>
          <p>
            Em determinadas operações, pode haver liberação de um valor
            adicional, conforme o saldo devedor, margem disponível, prazo e
            condições aprovadas pela instituição financeira.
          </p>

          <p>
            O valor, quando disponível, deve ser informado na proposta antes
            da contratação.
          </p>
        </>
      ),
    },

    {
      question: "O que é o cartão RMC?",
      content: (
        <>
          <p>
            O RMC está relacionado à Reserva de Margem Consignável utilizada
            em operações de cartão de crédito consignado.
          </p>

          <p>
            A disponibilidade, utilização da margem, análise e contratação
            dependem das regras aplicáveis e das condições aprovadas pela
            instituição financeira.
          </p>
        </>
      ),
    },

    {
      question: "O que é o cartão RCC?",
      content: (
        <>
          <p>
            O RCC está relacionado à Reserva de Cartão Consignado utilizada em
            operações de cartão consignado de benefício.
          </p>

          <p>
            A disponibilidade de margem, análise e contratação dependem das
            regras vigentes e das condições aprovadas pela instituição
            financeira responsável pela operação.
          </p>
        </>
      ),
    },

    {
      question: "Quem pode contratar o consignado de convênios?",
      content: (
        <>
          <p>
            O consignado de convênios é destinado a servidores vinculados a
            órgãos ou entidades que possuem convênio habilitado para essa
            modalidade de crédito.
          </p>

          <p>
            A Egel atende servidores efetivos, ativos e inativos, de convênios
            que estejam disponíveis para contratação, conforme as regras do
            respectivo órgão, entidade e instituição financeira.
          </p>

          <p>
            A existência de vínculo ou margem disponível não garante a aprovação
            do crédito. A análise e a contratação dependem das regras do
            convênio e das condições aprovadas pela instituição financeira.
          </p>
        </>
      ),
    },

    {
      question: "O que é o Empréstimo CLT?",
      content: (
        <>
          <p>
            O Empréstimo CLT, também conhecido como Crédito do Trabalhador, é
            uma modalidade de crédito consignado destinada a trabalhadores com
            vínculo formal de emprego regido pela CLT.
          </p>

          <p>
            As parcelas são descontadas diretamente da folha de pagamento,
            conforme as regras do programa e da operação contratada. O trabalhador
            pode solicitar propostas por meio da Carteira de Trabalho Digital,
            e a contratação está sujeita à análise da instituição financeira.
          </p>

          <p>
            O programa também possui regras específicas relacionadas às garantias
            da operação, incluindo possibilidades envolvendo FGTS e verbas
            rescisórias, conforme a legislação vigente.
          </p>

          <p>
            A Egel pode auxiliar na orientação e intermediação, quando aplicável.
            A aprovação, definição das condições e contratação são realizadas
            pela instituição financeira responsável pela operação.
          </p>
        </>
      ),
    },

    {
      question: "Posso fazer uma simulação antes de contratar?",
      content: (
        <>
          <p>
            Sim. A simulação permite verificar as possibilidades disponíveis
            para o seu perfil antes de decidir pela contratação.
          </p>

          <p>
            A Egel pode auxiliar durante esse processo, mas a simulação não
            representa aprovação ou garantia de contratação. A decisão final
            cabe à instituição financeira responsável pela operação.
          </p>
        </>
      ),
    },

    {
      question: "A Egel é quem concede o empréstimo?",
      content: (
        <>
          <p>
            Não. A Egel não é a instituição responsável pela concessão do
            crédito.
          </p>

          <p>
            Atuamos na intermediação e orientação dos clientes. A análise,
            aprovação, definição das condições e contratação são realizadas
            pela instituição financeira responsável pela operação.
          </p>
        </>
      ),
    },

    {
      question: "Falar com a Egel tem algum custo ou compromisso?",
      content: (
        <>
          <p>
            Não. Entrar em contato com nossa equipe serve para esclarecer
            dúvidas, realizar simulações e verificar as possibilidades
            disponíveis, sem obrigação de contratação.
          </p>

          <p>
            Nenhuma operação é contratada diretamente com a Egel. Caso uma
            proposta seja aprovada, a contratação ocorre com a instituição
            financeira responsável pela operação.
          </p>
        </>
      ),
    },
  ];


  const handleNavigation = (e) => {
    handleSectionNavigation(
      e,
      "contato",
      navigate,
      scrollToSection,
      onNavigate
    );
  };

  const handleSimulatorNavigation = (e) => {
    handleSectionNavigation(
      e,
      "simulador",
      navigate,
      scrollToSection,
      onNavigate
    );
  };

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <section id="serviços" className="section services">
      <div className="container">
        <div className="services-grid">
          {services.map((service, index) => {
            const active = activeService === index;

            return (
              <article
                className={`service ${active ? "active" : ""}`}
                key={service.id}
                onClick={() => setActiveService(index)}
                style={{
                  "--service-image": `url(${service.image})`,
                }}
              >
                <div className="service-content">
                  <div className="service-info">
                    <h2>{service.title}</h2>

                    <div className="service-description">
                      <p>{service.description}</p>

                      <div className="service-actions">
                        <a
                          href="#contato"
                          className="btn btn-primary"
                          onClick={handleNavigation}
                        >
                          <span>Fale Conosco</span>
                          <FiArrowUpRight size={16} />
                        </a>

                        {service.id === "portabilidade" && (
                          <a
                            href="#simulador"
                            className="btn btn-secondary"
                            onClick={handleSimulatorNavigation}
                          >
                            <span>Simule agora</span>
                            <FiArrowUpRight size={16} />
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        <div id="serviços-faq" className="services-faq">
          <div className="section-content section-head">
            <h2 className="title">Perguntas Frequentes</h2>

            <p className="subtitle">
              Tire suas dúvidas sobre os serviços que disponibilizamos.
            </p>
          </div>

          <div className="faq-list">
            {faqs.map((faq, index) => {
              const active = activeFaq === index;

              return (
                <article
                  className={`faq-item ${active ? "active" : ""}`}
                  key={faq.question}
                >
                  <button
                    type="button"
                    className="faq-question"
                    onClick={() => toggleFaq(index)}
                    aria-expanded={active}
                  >
                    <span>{faq.question}</span>

                    <span className="faq-icon">
                      <FiChevronDown size={18} />
                    </span>
                  </button>

                  <div className="faq-answer">
                    <div className="faq-answer-content">{faq.content}</div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;